module.exports = __webpack_public_path__ + "aa49f123c6717e318609d8618240ce0d.svg";